<!--
 * @Description: 线索审核
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-24 17:00:33
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="t('operate.f6o14b')"
    width="670px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible">
      <a-form-item
        name="clueIdList"
        :label="t('operate.817co9')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <a-select
          v-model:value="editForm.clueIdList"
          mode="multiple"
          style="width: 100%"
          :disabled="true"
          :options="data"
          :fieldNames="{ label: 'customerName', value: 'clueId' }"
        ></a-select>
      </a-form-item>
      <a-form-item
        name="status"
        :label="t('operate.moulyj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <a-radio-group v-model:value="editForm.status" name="radioGroup">
          <a-radio value="1">{{ t('operate.73mu9a') }}</a-radio>
          <a-radio value="2">{{ t('operate.wslx3j') }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        name="auditOpinion"
        :label="t('common.remark')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <CosTextarea :maxlength="2000" :placeholder="t('common.pleaseInput')" v-model:value="editForm.auditOpinion" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { DcMessage } from '@dc-platform/dc-components'
import { clueApplyPass, clueRejectPass } from '@/api/overseasSales/clueManage'
import type { PotentialItem } from '@/typings/api/customerCenter'

const { t } = useI18n()
const data = ref<PotentialItem[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { status, auditOpinion, auditRecordIdList } = editForm.value
    try {
      // 通过
      let res
      if (status === '1') {
        res = await clueApplyPass({
          auditOpinion,
          auditRecordIdList
        })
      } else {
        res = await clueRejectPass({
          auditOpinion,
          auditRecordIdList
        })
      }
      DcMessage.success(t('operate.hup0do'))
      emit('success')
      visible.value = false
    } catch (err) {
      console.error(err)
    } finally {
      loading.value = false
    }
  })
}
const toggle = (rows: PotentialItem[]) => {
  if (!rows || !rows.length) {
    DcMessage.warning(t('operate.hn19ed'))
    return
  }
  data.value = rows
  const auditRecordIdList = rows.map((item) => item.recordId)
  const clueIdList = rows.map((item) => item.clueId)
  editForm.value = {
    auditRecordIdList,
    clueIdList,
    status: '1'
  }
  visible.value = true
}

defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'transferModel' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
</style>
